module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "para-s"
  }, [_vm._v("Each illustration appears at the beginning of the chapter to which it belongs.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1l"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_vm._v("Chapter 1: Syriac")])]), _vm._v(" "), _c('p', {
    staticClass: "para-s"
  }, [_vm._v("The beginning of Narsai’s mēmrā on Canaanite woman. Chaldean Cathederal, Mardin MS 60.19, fol. 204r (HMML project number CCM 00578). Image courtesy of Chaldean Cathedral, Mardin, Turkey, and the Hill Museum & Manuscript Library. Published with permission of the owners. All rights reserved.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1l"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Armenian")])]), _vm._v(" "), _c('p', {
    staticClass: "para-s"
  }, [_vm._v("The beginning of Grigor of Narek’s "), _c('em', [_vm._v("Book of Lamentation")]), _vm._v(". Armenian Patriarchate of Istanbul, Azgayin Matenadaran, Istanbul, Turkey, MS 131, fol. 3v (HMML project number APIA 00131). Image courtesy of the Armenian Patriarchate of Istanbul, Azgayin Matenadaran, Istanbul, Turkey, and the Hill Museum & Manuscript Library. Published with permission of the owners. All rights reserved.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1l"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Georgian")])]), _vm._v(" "), _c('p', {
    staticClass: "para-s"
  }, [_vm._v("A loose folio containing Georgian liturgical chants; this manuscript is also a palimpsest with two erased layers of earlier Syriac texts. Saint John’s University, Collegeville, MN, Hill Museum & Manuscript Library Special Collections, MS Frag. 32 (HMML project number SJRB 00154). Image courtesy of the Hill Museum & Manuscript Library. Published with permission of the owners. All rights reserved.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1l"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Arabic")])]), _vm._v(" "), _c('p', {
    staticClass: "para-s"
  }, [_vm._v("The beginning of "), _c('span', {
    staticClass: "f2"
  }, [_vm._v("Ḥ")]), _vm._v("unayn Ibn Is"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ḥ")]), _vm._v("āq’s "), _c('em', [_vm._v("How to Discern the True Religion")]), _vm._v(". Fondation Georges et Mathilde Salem, Aleppo, Syria, MS Ar 238, fol. 85r (HMML project number GAMS 01040). Image courtesy of Fondation Georges et Mathilde Salem, Aleppo, Syria; Chaldean Cathedral Mardin, Turkey, and the Hill Museum & Manuscript Library. Published with permission of the owners. All rights reserved.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1l"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Coptic")])]), _vm._v(" "), _c('p', {
    staticClass: "para-s"
  }, [_vm._v("The beginning of the "), _c('em', [_vm._v("Anaphora of Saint Thomas the Apostle")]), _vm._v(". Bibliothèque nationale de France, Paris, France, BnF copte 129.20, fol. 123r. Image courtesy of the Bibliothèque nationale de France. Published with permission of the owners. All rights reserved.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1l"
  }, [_c('span', {
    attrs: {
      "href": "#/047_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Ethiopic")])]), _vm._v(" "), _c('p', {
    staticClass: "para-s"
  }, [_vm._v("Part of the "), _c('em', [_vm._v("Letter of Eusebius to Carpianus")]), _vm._v(" in the Ethiopic Abba Gärima gospels. Abba Gärima I, "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "inline-image",
      "src": "images/E.jpg"
    }
  }), _vm._v("ndā Abba Gärima Monastery, Tigray Province, Ethiopia. Image courtesy of Michael Gervers (2004).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c1bea58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Illustrations.vue
// module id = 72
// module chunks = 0